/*
 * Split the time interval between `timeFrom` and `timeTo` into sub-intervals.
 * The number of sub-intervals should be `width`, to have 1 sub-interval for each pixel.
 * Within each sub-interval only keep minimum and maximum of the values and first and last value.
 * If any of those four values are the same, only keep each different value once.
 * There may be sub-intervals with no values, keep them empty.
 * Multiple values with the same time might occur.
 */
export const decimate = ({ timeFrom, timeTo, width, values }) => {
  // const startTime = new Date()
  const subIntervalWidth = Math.round((timeTo - timeFrom) / width) || 1
  const result = []
  let subIntervalStart = null
  let subIntervalMinTuple = null
  let subIntervalMaxTuple = null
  let subIntervalFirstTuple = null
  let subIntervalLastTuple = null

  const calculateSubIntervalStart = time => {
    const wholeSubIntervalsBeforeTime = Math.floor((time - timeFrom) / subIntervalWidth)
    return timeFrom + wholeSubIntervalsBeforeTime * subIntervalWidth
  }
  const closeSubInterval = () => {
    const minBeforeMax = subIntervalMinTuple[0] < subIntervalMaxTuple[0]
    const minMaxFirst = minBeforeMax ? subIntervalMinTuple : subIntervalMaxTuple
    const minMaxSecond = minBeforeMax ? subIntervalMaxTuple : subIntervalMinTuple
    // console.log('closing', subIntervalFirstTuple, minMaxFirst, minMaxSecond, subIntervalLastTuple)
    result.push(subIntervalFirstTuple)
    if (subIntervalFirstTuple[1] !== minMaxFirst[1]) {
      result.push(minMaxFirst)
    }
    if (minMaxFirst[1] !== minMaxSecond[1]) {
      result.push(minMaxSecond)
    }
    if (minMaxSecond[1] !== subIntervalLastTuple[1]) {
      result.push(subIntervalLastTuple)
    }
  }

  for (let index = 0; index < values.length; index++) {
    const tuple = values[index]
    const [time, value] = tuple
    // console.log('index', index, 'len', values.length, 'time', time, 'value', value)
    if (subIntervalStart === null) { // init first sub-interval
      subIntervalStart = calculateSubIntervalStart(time)
    }
    if (time >= subIntervalStart + subIntervalWidth) { // next sub-interval already
      closeSubInterval()
      subIntervalMinTuple = subIntervalMaxTuple = subIntervalFirstTuple = subIntervalLastTuple = null
      subIntervalStart = calculateSubIntervalStart(time)
    }
    if (subIntervalFirstTuple === null) {
      subIntervalFirstTuple = tuple
    }
    subIntervalLastTuple = tuple
    if (subIntervalMinTuple === null || value < subIntervalMinTuple[1]) {
      subIntervalMinTuple = tuple
    }
    if (subIntervalMaxTuple === null || value > subIntervalMaxTuple[1]) {
      subIntervalMaxTuple = tuple
    }
    if (index === values.length - 1) { // last value
      closeSubInterval()
    }
  }
  // console.log('Decimate @', new Date() - startTime, 'ms',
  //   { timeFrom, timeTo, width, subIntervalWidth }, values.length, '->', result.length)
  return result
}
